<template>
   <div class="modal" v-show="show">
    <div class="modal-wrapper">
      <div class="modal-container">
            <div class="modal-header">¡Información!</div>
            <div class="modal-body">
              <p>¿Por favor seleccionar la condición de venta del paquete?</p><br/>
              <select-input :options="options" v-model="paymentWay"></select-input>
            </div>
            <div class="modal-footer">
                <vs-button color="danger" type="border" icon="block" @click="closeModal()">No, Cancelar</vs-button>
                <vs-button  :disabled="confirmStatus || paymentWay.code == undefined" id="btnConfirm" color="success" @click="sendToBill()" type="border" icon="check" class="vs-con-loading__container">Si, Facturar</vs-button>
            </div>  
      </div>
    </div>
  </div>
</template>
<script>
import {helper} from '@/helpers/utils'
import SelectInput from '@/components/Form/Select-Input.vue'
import PackageDataService from "@/services/PackageDataService";
export default {
  name: 'ModalPaymentWay',
  mixins: [helper],
  components:{
    SelectInput
  },
  props: {
    show: { type: Boolean, required: true },
    packID: { type: String, required: true },
    customer: { type: Number, required: true },
    options: { type: Array, required: true, default: () => [] },
  },
  data() {
    return {
      active: false,
      paymentWay: {},
      packageId: this.packID,
      customerId: this.customer,
      confirmStatus: false,
      methods: [],
    }
  },
  watch: {
    packID () {
      this.packageId = this.packID
      this.customerId = this.customer
    }
  },
  methods: {
    closeModal () {
       this.$emit('modal-event', { status: "closed", active: false})
    },
    sendToBill() {
        this.confirmStatus = true
        PackageDataService.sendToBilled({ id: this.packageId, customer: this.customerId, paymentWay: this.paymentWay, finalized:1})
        .then(response => {
            console.log(response)
            this.confirmStatus = false
            this.$emit('modal-event', { message: response, status:"confirmed", response: this.newStatus, error: false, active: false})            
        })
        .catch(e => {
            console.log(e)
            this.confirmStatus = false
            this.$emit('modal-event', { message: e, status:"error", response: this.newStatus, error: true, active: false})              
        });
    },
  }
}
</script>
